/* @flow */
import * as React from 'react';
import cx from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { addBox, removeBox } from 'reducers/floatingBoxes';
import v4 from 'uuid/v4';
import BugNubFloatingBox from 'internal/components/BugNubFloatingBox';
import Image from 'components/Image';
import Link from 'components/Link';

import './styles/BugNubTrigger.scss';

type Props = {
  /* redux props */
  addBox: Function,
  removeBox: Function,
};

type State = {
  boxUuid: string,
  hidden: boolean,
};

class BugNubTrigger extends React.Component<Props, State> {
  state: State = {
    boxUuid: v4(),
    hidden: false,
  };

  handleClick = () => {
    this.toggleBugNub();
    this.props.addBox(
      this.state.boxUuid,
      <BugNubFloatingBox
        onToggle={this.toggleBugNub}
        remove={() => this.props.removeBox(this.state.boxUuid)}
      />
    );
  };

  toggleBugNub = () => {
    this.setState({
      hidden: !this.state.hidden,
    });
  };

  render() {
    return (
      <Link
        className={cx('BugNubTrigger', { 'BugNubTrigger--hidden': this.state.hidden })}
        onClick={this.handleClick}>
        <Image src={require('assets/images/bug-nub.svg')} width={75} />
      </Link>
    );
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ addBox, removeBox }, dispatch);
}

export { BugNubTrigger };

export default connect(
  undefined,
  mapDispatchToProps
)(BugNubTrigger);
